<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    scrollable
    :persistent="$vuetify.breakpoint.lgAndUp"
    :transition="$vuetify.breakpoint.lgAndUp ? '' : 'dialog-bottom-transition'"
  >
    <v-card :tile="$vuetify.breakpoint.mdAndDown" id="dialogPayment">
      <v-card-title class="text-uppercase">Payment Methods</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0" id="dialogPaymentContent">
        <v-window v-model="step">
          <v-window-item :value="0">
            <v-toolbar dense tile flat class="mt-2">
              <v-toolbar-title> Credit Card </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                text
                :color="buttonColor"
                @click="addNewCard"
                :disabled="cards == null"
              >
                <v-icon left>far fa-sparkles</v-icon>
                New Card</v-btn
              >
            </v-toolbar>
            <div class="pa-4 pt-0">
              <v-alert type="error" text v-model="hasErr" dismissible>
                <div class="subtitle-2">{{ errTitle || "ERROR" }}</div>
                <div>
                  {{ errMsg }}
                </div>
              </v-alert>
              <template v-if="cards == null">
                <v-card>
                  <div class="pa-4">
                    <div class="title mb-4">Getting cards</div>
                    <v-progress-linear
                      indeterminate
                      color="yellow darken-2"
                    ></v-progress-linear>
                  </div>
                </v-card>
              </template>
              <!-- <template v-else-if="cards != null && cards.length == 0">
                <div>
                  <v-alert type="info" text>
                    <div class="title">User have no cards yet!</div>
                    <div>Please add new card before checkout.</div>
                  </v-alert>
                </div>
              </template> -->
              <template v-else>
                <template v-if="cards.length == 0">
                  <div v-if="tempCard == null">
                    <v-alert type="info" text>
                      <div class="title">User have no cards yet!</div>
                      <div>Please add new card before checkout.</div>
                    </v-alert>
                  </div>
                </template>
                <template v-else>
                  <div v-if="tempCard == null">
                    <v-radio-group v-model="selectedCard" class="mb-0">
                      <template v-for="(card, idx) of cards">
                        <div
                          class="d-flex align-center mb-4"
                          :key="`cust_card_${idx}`"
                        >
                          <div class="pr-2">
                            <v-radio
                              name="cust_card"
                              :value="card.id"
                            ></v-radio>
                          </div>
                          <div class="flex-grow-1">
                            <credit-card
                              @click.native="selectedCard = card.id"
                              class="hoverable"
                              :card="card"
                              :align-center="true"
                              :show-bg="true"
                            ></credit-card>
                          </div>
                        </div>
                      </template>
                    </v-radio-group>
                  </div>
                </template>

                <div>
                  <template v-if="tempCard == null">
                    <!-- <v-btn
                      block
                      @click="usingTempCard"
                      color="blue darken-3"
                      outlined
                    >
                      <v-icon left>far fa-sparkles</v-icon>
                      Using a new card
                    </v-btn> -->
                  </template>
                  <template v-else>
                    <div class="text-center">
                      <div class="text-left subtitle-1 mb-4">
                        You will pay with below card without saving card.
                      </div>
                      <credit-card :card="tempCard"></credit-card>
                      <div class="mt-2 text-center">
                        <v-btn
                          small
                          text
                          :color="buttonColor"
                          @click="clearTempCard"
                          >Clear</v-btn
                        >
                        <v-btn
                          small
                          text
                          :color="buttonColor"
                          @click="changeTempCard"
                          >Edit</v-btn
                        >
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </v-window-item>
          <v-window-item :value="1">
            <div class="pa-4">
              <omise-form
                ref="omiseForm"
                @onUsingTempCard="onUsingTempCard"
                @onSaved="onSavedMyCard"
              ></omise-form>
            </div>
          </v-window-item>
        </v-window>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <template v-if="step == 0">
          <v-btn dark @click="close" text color="error" min-width="100">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            depressed
            :disabled="!canProceed || overlay"
            @click="proceedPayment"
            text
          >
            Checkout ฿{{ price | numFormat("0,0.00") }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn text color="grey darken-3" @click="onFormCancel"> Back </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="blue darken-2"
            depressed
            @click="proceedCheckout"
            min-width="120"
            text
          >
            Proceed
          </v-btn>
        </template>
      </v-card-actions>

      <v-overlay absolute :value="overlay" opacity="0.85">
        <div class="text-center">
          <v-progress-circular
            :size="50"
            color="amber"
            indeterminate
          ></v-progress-circular>

          <div class="mt-4 headline">Proceeding Payment...</div>
        </div>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import OmiseForm from "@/components/OmiseForm";
import CreditCard from "@/components/CreditCard";
import omiseService, { createToken } from "../services/omiseService";

export default {
  components: {
    OmiseForm,
    CreditCard,
  },
  data: () => ({
    overlay: false,
    step: 0,
    dialog: false,
    bundleId: null,
    price: 0,
    priceWithTax: 0,
    cards: null,
    tempCard: null,
    selectedCard: null,
    hasErr: false,
    errTitle: "",
    errMsg: "",
  }),
  computed: {
    buttonColor() {
      return (
        this.$userInfo.companies[0].buttonColor ||
        Vue.prototype.$userInfo.companies[0].buttonColor
      );
    },
    canProceed() {
      if (this.tempCard != null) {
        return true;
      } else {
        if (this.selectedCard != null) {
          return true;
        }
      }
      return false;
    },
  },
  mounted() {},
  watch: {
    step(val) {
      this.onWindowChange(val);
    },
    tempCard(val) {
      this.selectedCard = null;
      // if (val != null) {
      //   this.selectedCard = null;
      // }
    },
  },
  methods: {
    open(args) {
      const { bundleId, price } = args;
      this.bundleId = bundleId;
      this.price = price;
      this.dialog = true;

      this.init();
    },
    init() {
      this.loadCards();
    },
    loadCards(isSetDefault = true) {
      this.cards = null;
      // this.$http.get(`/finance/student/omise/invno`).then((resp) => {
      //   console.log(resp.data);
      // });
      omiseService
        .listCards()
        .then((resp) => {
          if (resp.data.status == true && resp.data.result.total > 0) {
            let tmpArr = [];
            for (const rawCard of resp.data.result.data) {
              tmpArr.push({
                id: rawCard.id,
                holderName: rawCard.name,
                cardNo: rawCard.last_digits,
                cardNoText: rawCard.last_digits,
                expires: `${rawCard.expiration_month
                  .toString()
                  .padStart(2, 0)}/${rawCard.expiration_year}`,
                secureCode: `∗∗∗`,
                cardType: rawCard.brand.toLowerCase(),
              });
            }
            this.cards = tmpArr;
            if (isSetDefault) {
              this.selectedCard = this.cards[0].id;
            }
          } else {
            this.cards = [];
          }
        })
        .catch((err) => {
          this.cards = [];
        });
    },
    addNewCard() {
      this.tempCard = null;
      this.step = 1;
    },
    changeTempCard() {
      this.hasErr = false;
      this.step = 1;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.omiseForm.setForm(this.tempCard, false);
        }, 100);
      });
    },
    clearTempCard() {
      this.hasErr = false;
      this.tempCard = null;
      this.loadCards();
    },
    onUsingTempCard(card) {
      this.tempCard = card;
      this.step = 0;
    },
    onSavedMyCard() {
      this.clearTempCard();
      this.step = 0;
    },
    onFormCancel() {
      this.$refs.omiseForm.clear();
      this.step = 0;
    },
    proceedCheckout() {
      this.$refs.omiseForm.submitForm();
    },
    close() {
      this.cards = null;
      this.bundleId = null;
      this.step = 0;
      this.overlay = false;
      this.price = 0;
      this.tempCard = null;
      this.errTitle = "";
      this.errMsg = "";
      this.hasErr = false;
      this.dialog = false;
    },
    onWindowChange(val) {
      if (val == 0) {
        this.loadCards();
      } else if (val == 1) {
        this.$nextTick(() => {
          setTimeout(() => {
            // this.$refs.omiseForm.test();
          }, 100);
        });
      }
    },
    proceedPayment() {
      if (this.tempCard != null) {
        this.overlay = true;
        // using temp card
        createToken(this.tempCard)
          .then((tokenId) => {
            return omiseService.charge({
              tokenId,
              bundle: this.bundleId,
              course: this.$route.params.id,
            });
          })
          .then((resp) => {
            this.proceedPaymentSuccessHandler(resp.data);
          })
          .catch((err) => {
            this.proceedPaymentErrorHandler(err);
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        if (this.selectedCard != null) {
          this.overlay = true;
          omiseService
            .charge({
              card: this.selectedCard,
              bundle: this.bundleId,
              course: this.$route.params.id,
            })
            .then((resp) => {
              this.proceedPaymentSuccessHandler(resp.data);
            })
            .catch((err) => {
              this.proceedPaymentErrorHandler(err);
            })
            .finally(() => {
              this.overlay = false;
            });
        } else {
          // show required card
          this.proceedPaymentErrorHandler({
            object: "error",
            code: "Card is required",
            message: "Please select card to proceed.",
          });
        }
      }
    },
    proceedPaymentSuccessHandler(data) {
      if (data.status == true) {
        if (data.result.paid) {
          // paid
          this.$emit("onSuccess", data.result);
        } else {
          // can not paid
          this.proceedPaymentErrorHandler({
            object: "error",
            code: data.result.failureCode,
            message: data.result.failureMessage,
          });
        }
      } else {
        this.proceedPaymentErrorHandler(
          data.message || "Something went wrong, unable to proceed checkout"
        );
      }
    },
    proceedPaymentErrorHandler(err) {
      let errTitle = "";
      let errMsg = "";
      if (err.object != null && err.object == "error") {
        errTitle = "ERROR: " + err.code;
        errMsg = err.message;
      } else {
        errTitle = "ERROR";
        if (err.response) {
          errMsg = err.response.data.message;
        } else {
          errMsg = err.toString() || JSON.stringify(err);
        }
      }
      this.errTitle = errTitle;
      this.errMsg = errMsg;
      this.hasErr = true;

      this.$nextTick(() => {
        // scroll to top
        this.$vuetify.goTo(0, {
          container: "#dialogPaymentContent",
        });
      });
    },
  },
};
</script>